import React, { useState, useEffect } from 'react';
import { Container, Title, Text, Box, Divider, Stack } from '@mantine/core';
import { SimpleHeader } from '../components/shared/SimpleHeader';
import { SimpleFooter } from '../components/shared/SimpleFooter';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

export function PrivacyPolicy() {
  const [markdownContent, setMarkdownContent] = useState<string>('');
  const [lastUpdated, setLastUpdated] = useState<string>('May 1, 2025');

  useEffect(() => {
    // Fetch the markdown content
    fetch('/PrivacyPolicy.md')
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to load privacy policy');
        }
        return response.text();
      })
      .then(text => {
        setMarkdownContent(text);
      })
      .catch(error => {
        console.error('Error loading privacy policy:', error);
        // Fallback: try to load from the relative path
        fetch('/landing/PrivacyPolicy.md')
          .then(response => response.ok ? response.text() : Promise.reject('Failed to load from alternate path'))
          .then(text => setMarkdownContent(text))
          .catch(err => console.error('Error loading from alternate path:', err));
      });
  }, []);

  return (
    <>
      <SimpleHeader />
      <Container size="lg" py="xl" mt={80}>
        <Title order={1} mb="lg">Privacy Policy</Title>
        <Text mb="xl">Last Updated: {lastUpdated}</Text>

        <Divider my="lg" />

        <Stack>
          <Box className="markdown-content">
            {markdownContent ? (
              <ReactMarkdown
                remarkPlugins={[remarkGfm]}
                components={{
                  h1: ({children}) => <Title order={1} mb="md">{children}</Title>,
                  h2: ({children}) => <Title order={2} mb="md" mt="xl">{children}</Title>,
                  h3: ({children}) => <Title order={3} mb="sm" mt="lg">{children}</Title>,
                  p: ({children}) => <Text mb="md">{children}</Text>,
                  a: ({href, children}) => <Text component="a" href={href} target="_blank" rel="noopener noreferrer" c="blue">{children}</Text>,
                  ul: ({children}) => <Box component="ul" ml="md" mb="md">{children}</Box>,
                  li: ({children}) => <Box component="li" mb="xs">{children}</Box>,
                  hr: () => <Divider my="lg" />
                }}
              >
                {markdownContent}
              </ReactMarkdown>
            ) : (
              <Text>Loading privacy policy...</Text>
            )}
          </Box>
        </Stack>
      </Container>
      <SimpleFooter />
    </>
  );
}
